if(typeof _GIRL_CONF['lola']['game_memory']=='undefined'){_GIRL_CONF['lola']['game_memory']={};};
_GIRL_CONF['lola']['game_memory']['face']={left:554,top:115,width:110,height:192};
_GIRL_CONF['lola']['game_memory']['hair']={left:495,top:24,width:335,height:306};
_GIRL_CONF['lola']['game_memory']['hand']={left:502,top:283,width:303,height:318};
_GIRL_CONF['lola']['game_memory']['item1']={left:186,top:247,width:228,height:438};
_GIRL_CONF['lola']['game_memory']['item2']={left:958,top:362,width:146,height:293};
_GIRL_CONF['lola']['game_memory']['item3']={left:347,top:594,width:594,height:138};
_GIRL_CONF['lola']['game_memory']['tit1']={left:488,top:341,width:94,height:124};
_GIRL_CONF['lola']['game_memory']['tit2']={left:568,top:350,width:122,height:121};
